import { ROUTE_PORTFOLIO_DEMO, ROUTE_PORTFOLIO_NEW } from '@/constants/routes';
import { useFlag } from '@/features/unleash';
import { getStaticUrl, useCloudflareImage } from '@/hooks/useCloudflareImage';
import { Box, Grid, Text, Button } from '@simplywallst/ui-core';
import { useDispatch } from 'react-redux';
import { useTracking } from 'react-tracking';

export const PortfolioCta = () => {
  const dispatch = useDispatch();
  const featureFlag = useFlag({
    name: 'mono-portfolio-dashboard-cta',
  });
  const image = useCloudflareImage({
    src: getStaticUrl('portfolio-holding-valuation.png'),
    width: 160,
    height: 108,
    fit: 'cover',
  });

  const { trackEvent } = useTracking();

  if (featureFlag.variant.name !== 'variant') return;
  return (
    <Box
      backgroundColor="phantom"
      marginBottom="x2"
      marginRight="x2"
      marginRightSm="x3"
      marginLeft="x2"
      marginLeftSm="x3"
      borderRadius="x1_5"
    >
      <Grid
        templateColumnsSm="160px 1fr"
        templateColumns="1fr"
        gap="16px"
        gapSm="24px"
        padding="x2"
      >
        <Box
          width="160px"
          height="108px"
          backgroundColor="charcoal"
          borderRadius="x1"
        >
          <img src={image} alt="Analyzed Portfolios" />
        </Box>
        <Grid alignContent="space-between" gap="8px">
          <Text typography="smallStrong">
            Analyze your own portfolio in minutes.
          </Text>
          <Text typography="xSmall" color="textSoft">
            Track fair values, derisk your holdings and improve your
            composition.
          </Text>
          <Box marginTop="x1">
            <Button
              styleType="louderLarge"
              marginRight
              onClick={() => {
                trackEvent({
                  subject: 'portfolioCta',
                  modifier: 'createNewPortfolio',
                  action: 'click',
                });
                dispatch({ type: ROUTE_PORTFOLIO_NEW });
              }}
            >
              Add my portfolio
            </Button>
            <Button
              styleType="loudLarge"
              marginLeft
              onClick={() => {
                trackEvent({
                  subject: 'portfolioCta',
                  modifier: 'portfolioDemo',
                  action: 'click',
                });
                dispatch({ type: ROUTE_PORTFOLIO_DEMO });
              }}
            >
              View a demo
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};
